export const SELECTED_SCREEN = {
    OFF_VIEW: 0,
    SELECT_FILES: 1,
    MARKUP: 2,
    FINAL_UPLODING_VIEW: 3,
    NOTIFY_USER_VIEW: 4,
    MARKUP_WITH_DONE: 5,
};

export const SUB_SCREEN = {
    OFF_VIEW: 0,
    CAMERA_VIEW: 11,
    MARKUP_LOADING_IMAGE: 12,
};

export const UPLOADING_FILE_STATUS = {
    NOTHING: 0,
    COMPRESSING: 1,
    UPLOADING: 2,
    UPLOAD_SUCCESS: 3,
    UPLOAD_FAILED: 4,
    DELETING_FILE: 5,
    RETRY_SINGLE: 6,
    READY_TO_UPLOAD: 7,
    MARKUP: 8,
};

export const FILE_UPLOAD_LIMITATION = {
    SINGLE_UPLOAD_MAX_ALLOWED_FILE_COUNT: 5,
    SINGLE_UPLOAD_LIMIT_REACH_COUNT: 6,
    IMAGE_SIZE_LIMITATION_IN_MB: 20,
    IMAGE_MAX_ALLOWED_WIDTH_OR_HEIGHT: 1600,
};

export const MAX_ALLOWED_FILE_IN_SINGLE_TIME = 20;
export const REMAINING_FILE_COUNT_TO_MATCH = 1;
export const UPLOAD_FILE_MARKUP_CAPTION_MAX_LENGTH = 2000;

export const UPLOAD_TYPE_PARAM_FOR_UPLOAD_FILES = 1;

export const SUPPORTED_IMAGE_TYPES = ["image/png", "image/jpeg", "image/jpg"];

export const PICKED_FILES_FROM = {
    FROM_CAMERA: 0,
    FROM_GALLERY: 1,
    NONE: 100,
};

export const UPLOAD_FILES_DATA = {
    logFileArray: [],
    pickedFilesFrom: PICKED_FILES_FROM.NONE,
    selectedImageIndex: -1, //use default value to -1 for first time loading and set it to 0 once all images loaded
    selectedImageObj: null,
    annCanvas: false,
};

export const UPLOAD_TYPE = {
    EMPTY: "",
    UPLOAD_ONLY: "UPLOAD_ONLY",
    FROM_DEVICE: "FROM_DEVICE",
    FROM_CAMERA: "FROM_CAMERA",
};

export const IMAGE_OBJ_KEYS = {
    ID: "id",
    SIZE: "size",
    SOURCE: "src",
    UPDATED_SOURCE: "updatedSrc",
    COMPRESSED_IMAGE: "compressedImage",
    CAPTION: "caption",
    EXTENSION: "extension",
    TYPE: "type",
    LATITUDE: "lat",
    LONGITUDE: "long",
    UPLOADING_STATUS: "uploadingStatus",
    THUMBNAIL: "thumbnail",
    FILE_NAME: "fileName",
};

export const FROM_WHERE = {
    GALLERY: "Gallery",
    CAMERA: "Camera",
};

export const UPLOADING_STATUS_FOR_TOAST = {
    UPLOADING: "uploading",
    COMPLETE: "complate",
    RETRY: "retry",
};

export const UPLOAD_FILE_DATA_TRACK_STATUS = {
    START: "1",
    END: "2",
    REMAINING_COUNT: "3",
};
export const MAX_IMAGE_COUNT_OF_INDEXED_DB = 20; // Maximum number of images allowed in IndexedDB
